/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentCard/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Events from './Events/index'
import Images from './Images/index'
import Notes from './Notes/index'
import React from 'react'
import Summary from './Summary/index'
import Treatment from './Treatment/index'
import TxPlanNotes from './TxPlanNotes/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function TreatmentCard({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard"
  
}) {
  let isMedia = useIsMedia()
let tabPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'patient_id',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
 data="tab.patient_id"
 patientId={tabPatientIdValueData}
 patientTab="treatment"
/>
<div
  data-testid="TreatmentCard.Vertical"
  data-view-path={viewPath}
 style={{'--oy-1-b12TX': isMedia.mobile ? "auto" : "hidden"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="TreatmentCard.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-2-b12TX': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-3-b12TX': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-6-b12TX': dtColorsNeutral400,'--pl-4-b12TX': isMedia.mobile ? "0px" : typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-5-b12TX': isMedia.mobile ? "0px" : typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--fw-7-b12TX': isMedia.mobile ? "wrap" : "nowrap"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TreatmentCard.Vertical:1"
  data-view-path={viewPath}
 style={{'--w-8-b12TX': isMedia.mobile ? "100%" : "330px"}}
 className={`views-block ${styles.Vertical1}`}
>
<Treatment
  viewPath={`${viewPath}/Treatment`}
/>
<Summary
  viewPath={`${viewPath}/Summary`}
/>
</div>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 alignSelf="flex-start"
 marginLeft={dtSpaceM}
 marginRight={dtSpaceM}
 flexGrow={1}
 flexBasis="auto"
 height={isMedia.mobile ? "auto" : "260px"}
 width="auto"
 marginTop={isMedia.mobile ? dtSpaceXs : "0px"}
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={dtSpaceXxs}
 paddingRight={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 paddingLeft={dtSpaceXxs}
>
{childProps => (
<React.Fragment>
<Notes
{...childProps}
  viewPath={`${viewPath}/Notes`}
/>
<TxPlanNotes
{...childProps}
  viewPath={`${viewPath}/TxPlanNotes`}
/>
</React.Fragment>
)}
</TysiaCardContent>
)}
</TysiaCard>
<Images
  viewPath={`${viewPath}/Images`}
/>
</div>
<Events
  viewPath={`${viewPath}/Events`}
/>
</div>
{children}
</React.Fragment>)
}